/*
 * breakpts
 * javascript / css utility to get current screen size (breakpoints)
 */

// declare
var breakpts = {};

// current value
breakpts.init = function () {
	this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
};

// init
breakpts.init();
window.addEventListener("resize", function () {
	breakpts.init();
});